import { LazyLoad } from '@petconsole/pure-fe-mui';

const VanAdmin = LazyLoad(() => import('./VanAdmin'));

export { VanAdmin };
